export const HIDDEN_EXPIRED_ORDERS_STORAGE_KEY = 'provi:hidden-expired-orders:v1';

const HIDEABLE_EXPIRED_RIDE_STATUSES = new Set([
  'expired_no_driver',
  'auto_cancel_driver_delay'
]);

export function getClientVisibilityKey(user) {
  const value = user?.id || user?._id || user?.email;
  return value == null ? '' : String(value).trim().toLowerCase();
}

export function getPersistentOrderId(order) {
  const value = order?.id || order?._id || order?.ride_id || order?.order_id;
  return value == null ? '' : String(value);
}

export function isHideableExpiredRide(ride) {
  return Boolean(
    getPersistentOrderId(ride)
    && HIDEABLE_EXPIRED_RIDE_STATUSES.has(String(ride?.status || '').toLowerCase())
  );
}

function getBrowserStorage() {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage;
  } catch (error) {
    return null;
  }
}

export function readHiddenExpiredOrderIds(user, storage = getBrowserStorage()) {
  const userKey = getClientVisibilityKey(user);
  if (!userKey || !storage) return [];

  try {
    const stored = JSON.parse(storage.getItem(HIDDEN_EXPIRED_ORDERS_STORAGE_KEY) || '{}');
    const ids = stored && !Array.isArray(stored) ? stored[userKey] : [];
    return Array.isArray(ids) ? [...new Set(ids.map(String).filter(Boolean))] : [];
  } catch (error) {
    return [];
  }
}

export function writeHiddenExpiredOrderIds(user, orderIds, storage = getBrowserStorage()) {
  const userKey = getClientVisibilityKey(user);
  if (!userKey || !storage) return false;

  try {
    const parsed = JSON.parse(storage.getItem(HIDDEN_EXPIRED_ORDERS_STORAGE_KEY) || '{}');
    const stored = parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    stored[userKey] = [...new Set((orderIds || []).map(String).filter(Boolean))];
    storage.setItem(HIDDEN_EXPIRED_ORDERS_STORAGE_KEY, JSON.stringify(stored));
    return true;
  } catch (error) {
    return false;
  }
}
